var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSalesAgent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 180.007,
    height: 200.826,
    viewBox: "0 0 180.007 200.826",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1457",
    "data-name": "Group 1457",
    transform: "translate(-1172 -581.416)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-briefcase",
    "data-name": "Icon ionic-ios-briefcase",
    transform: "translate(1172 672.59)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_284",
    "data-name": "Path 284",
    d: "M12.513,79.714H113.028a9.128,9.128,0,0,0,9.138-9.138V15.75H3.375V70.576A9.128,9.128,0,0,0,12.513,79.714Z",
    transform: "translate(-3.375 29.939)",
    fill: "#8f8b98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_285",
    "data-name": "Path 285",
    d: "M113.028,22.775h-2.284V20.491a2.291,2.291,0,0,0-2.284-2.284H99.321a2.291,2.291,0,0,0-2.284,2.284v2.284h-8V13.638A9.165,9.165,0,0,0,79.9,4.5H45.637A9.165,9.165,0,0,0,36.5,13.638v9.138h-8V20.491a2.291,2.291,0,0,0-2.284-2.284H17.082A2.291,2.291,0,0,0,14.8,20.491v2.284H12.513a9.128,9.128,0,0,0-9.138,9.138V43.335h118.79V31.913A9.128,9.128,0,0,0,113.028,22.775Zm-31.982,0H44.495v-8A2.291,2.291,0,0,1,46.779,12.5H78.761a2.291,2.291,0,0,1,2.284,2.284Z",
    transform: "translate(-3.375 -4.5)",
    fill: "#8f8b98"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Sales_Person",
    "data-name": "Sales Person",
    transform: "translate(1229.569 581.416)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_555",
    "data-name": "Rectangle 555",
    width: 0.537,
    height: 4.967,
    transform: "translate(19.671 10.044)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_557",
    "data-name": "Rectangle 557",
    width: 37.589,
    height: 0.537,
    transform: "translate(11.885 35.417)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_558",
    "data-name": "Rectangle 558",
    width: 0.537,
    height: 4.967,
    transform: "translate(22.088 30.584)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_559",
    "data-name": "Rectangle 559",
    width: 0.537,
    height: 4.967,
    transform: "translate(38.466 30.584)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_560",
    "data-name": "Rectangle 560",
    width: 37.589,
    height: 0.537,
    transform: "translate(61.825 47.499)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_561",
    "data-name": "Rectangle 561",
    width: 0.537,
    height: 4.967,
    transform: "translate(72.028 42.666)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_562",
    "data-name": "Rectangle 562",
    width: 0.537,
    height: 4.967,
    transform: "translate(88.406 42.666)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_563",
    "data-name": "Rectangle 563",
    width: 37.589,
    height: 0.537,
    transform: "translate(58.066 172.08)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_564",
    "data-name": "Rectangle 564",
    width: 0.537,
    height: 4.967,
    transform: "translate(68.269 167.247)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_565",
    "data-name": "Rectangle 565",
    width: 0.537,
    height: 4.967,
    transform: "translate(84.647 167.247)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_568",
    "data-name": "Rectangle 568",
    width: 0.537,
    height: 4.967,
    transform: "translate(20.477 81.061)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_570",
    "data-name": "Rectangle 570",
    width: 0.537,
    height: 4.967,
    transform: "translate(15.913 145.768)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_571",
    "data-name": "Rectangle 571",
    width: 0.537,
    height: 4.967,
    transform: "translate(32.29 145.768)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_572",
    "data-name": "Rectangle 572",
    width: 37.589,
    height: 0.537,
    transform: "translate(65.852 131.001)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_573",
    "data-name": "Rectangle 573",
    width: 0.537,
    height: 4.967,
    transform: "translate(76.055 126.168)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_574",
    "data-name": "Rectangle 574",
    width: 0.537,
    height: 4.967,
    transform: "translate(92.433 126.168)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_580",
    "data-name": "Rectangle 580",
    width: 122.438,
    height: 0.537,
    transform: "translate(0 200.028)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_315",
    "data-name": "Path 315",
    d: "M747.411,135.809s3.925,11.171,1.51,12.89,8.152,15.754,8.152,15.754l12.681-3.437-6.944-11.744s-.906-11.744-.906-13.463S747.411,135.809,747.411,135.809Z",
    transform: "translate(-705.679 -119.196)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_316",
    "data-name": "Path 316",
    d: "M747.411,135.809s3.925,11.171,1.51,12.89,8.152,15.754,8.152,15.754l12.681-3.437-6.944-11.744s-.906-11.744-.906-13.463S747.411,135.809,747.411,135.809Z",
    transform: "translate(-705.679 -119.196)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_317",
    "data-name": "Path 317",
    d: "M721.487,411.449s-1.146,14.322,0,21.769,2.864,28.071,2.864,28.071,0,38.956,6.3,39.528,10.885,1.146,11.457-1.146-2.864-3.437-1.146-4.583,2.291-5.156,0-9.739,0-50.986,0-50.986l10.885,29.216s1.146,24.061,2.291,27.5-1.146,9.739,2.864,10.312,8.593-2.864,10.885-4.01-3.437-1.146-2.291-1.719,4.583-2.291,3.437-2.864-2.292-28.071-2.292-28.071-3.151-58.719-7.161-61.011-6.588,1.656-6.588,1.656Z",
    transform: "translate(-686.343 -315.206)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_318",
    "data-name": "Path 318",
    d: "M755.036,758.784v4.583s-5.156,12.458,0,12.458,9.166,1.291,9.166-.428V759.93Z",
    transform: "translate(-709.581 -575.464)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_319",
    "data-name": "Path 319",
    d: "M862.192,758.754v4.583s5.156,12.458,0,12.458-9.166,1.291-9.166-.428V759.9Z",
    transform: "translate(-782.938 -575.442)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_152",
    "data-name": "Ellipse 152",
    cx: 10.312,
    cy: 10.312,
    r: 10.312,
    transform: "translate(39.44 4.297)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_320",
    "data-name": "Path 320",
    d: "M762.425,201.9s2.864,8.593,7.447,6.874l4.583-1.719,8.02,55s-6.3,9.166-15.468,3.437S762.425,201.9,762.425,201.9Z",
    transform: "translate(-715.824 -168.1)",
    fill: "#ffe200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321",
    "data-name": "Path 321",
    d: "M795.418,180.672,798,175.229s15.181,7.161,17.472,9.452a8.947,8.947,0,0,1,2.292,5.729l-4.01,14.322s1.146,31.508,1.146,32.654,4.01,7.447,1.146,5.156-3.437-4.583-5.729-1.146-7.447,7.447-7.447,7.447Z",
    transform: "translate(-740.797 -148.591)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_322",
    "data-name": "Path 322",
    d: "M842.657,349.122l-1.719,16.04s-10.312,9.166-8.02,9.739,3.437-1.719,3.437-1.719,4.01,4.01,6.3,1.719,8.02-24.061,8.02-24.061Z",
    transform: "translate(-767.986 -275.794)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_323",
    "data-name": "Path 323",
    d: "M745.506,76.049c-2.286-.082-4.732-.122-6.66,1.11a9.749,9.749,0,0,0-2.3,2.253c-1.877,2.373-3.5,5.359-2.8,8.3l.81-.316a5.3,5.3,0,0,1-.512,2.272c.114-.331.5.2.394.54l-.892,2.927a2.756,2.756,0,0,1,3.514,2.1c.1-3.4.455-7.3,3.212-9.288a11.113,11.113,0,0,1,4.844-1.582,9.744,9.744,0,0,1,4.7.024c1.5.514,2.771,2.045,2.431,3.59a1.6,1.6,0,0,1,1.8.888A4.665,4.665,0,0,1,754.412,91c.736.52,1.572-.512,1.872-1.362a12.289,12.289,0,0,0,.95-6.195c-.379-2.08-2.074-4.067-4.187-4.074a1.468,1.468,0,0,0,.382-1.033l-1.742-.147a1.926,1.926,0,0,0,1.151-.607C752.138,78.355,746.637,76.09,745.506,76.049Z",
    transform: "translate(-695.535 -76.014)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_324",
    "data-name": "Path 324",
    d: "M712.175,177.376s-4.664-4.57-6.342-4.29-3.97,4.29-3.97,4.29-13.749,4.583-13.176,9.166,6.875,26.925,6.875,26.925,5.156,26.925.573,29.79,21.769,10.312,22.342,6.874,1.719-37.81,0-42.966S712.175,177.376,712.175,177.376Z",
    transform: "translate(-662.71 -147.014)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_325",
    "data-name": "Path 325",
    d: "M850.893,223.236h7.084s4.947,21.769,5.52,24.061,1.719,13.176,1.146,13.176-12.03-2.292-12.03-.573Z",
    transform: "translate(-781.377 -183.708)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_326",
    "data-name": "Path 326",
    d: "M770.482,328.187H743.365c-2.646-12.174-2.867-23.935,0-35.173h27.118C766.106,304.049,765.833,315.73,770.482,328.187Z",
    transform: "translate(-701.206 -234.751)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_327",
    "data-name": "Path 327",
    d: "M707.938,354.469l8.02,3.437s15.468,2.291,15.468-4.01-15.468-2.864-15.468-2.864l-5.156-1.649Z",
    transform: "translate(-676.805 -275.985)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328",
    "data-name": "Path 328",
    d: "M680.17,210.435l-6.875,1.719-5.156,30.362s-1.719,8.02,1.146,8.593,10.885,5.156,10.885,5.156,1.145-8.593,3.437-8.593l-5.729-4.583,3.437-20.051Z",
    transform: "translate(-647.317 -174.344)",
    fill: "#3f3d56"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesAgent);
export default __webpack_public_path__ + "static/media/Sales-Agent.661b2b6309fd1b3443a01d5deaf930bd.svg";
export { ForwardRef as ReactComponent };